export default (count) => ({
    active: 1,
    count: count,
    back: false,
  
    cardClass(index) {
      if (index == this.active) {
        return "review-card--1";
      }
      if (index == (this.active + 1) % (this.count)) {
        return 'review-card--2'
      }
  
      if (index == (this.active + 2) % (this.count )) {
        return 'review-card--3'
      }
      if (index == (this.active + 3) % (this.count )) {
        return 'review-card--4'
      }
    },
  
    clickSelect(index) {
      const forwardSteps = (index - this.active + this.count) % this.count;
      const backwardSteps = (this.active - index + this.count) % this.count;
  
      const direction = forwardSteps <= backwardSteps ? 'forward' : 'backward';
      const steps = Math.min(forwardSteps, backwardSteps);
  
  
      let step = 0;
  
      // Perform the first step immediately
      if (direction === 'forward') {
        this.active = (this.active + 1) % this.count;
      } else {
        this.active = (this.active - 1 + this.count) % this.count;
      }
  
      step++;
  
      // Use setInterval for the remaining steps
      const interval = setInterval(() => {
        if (step >= steps) {
          clearInterval(interval); // Stop the interval when steps are completed
          return;
        }
  
        // Update active index based on direction
        if (direction === 'forward') {
            this.active = (this.active + 1) % this.count;
        } else {
            this.active = (this.active - 1 + this.count) % this.count;
        }
  
        step++;
      }, 600); // 0.6 seconds per step
    },
  
  });
  